/*********************************************************************************************
 * Initialize the Splide carousel for the cart section.
 *
 */
function mmInitSplideRea() {
	const id = ".splide-rea";
	const splideElem = document.querySelector(id);

	if (splideElem) {
		if (splideElem.splideInstance) {
			splideElem.splideInstance.destroy(true);
		}
		splideElem.splideInstance = new Splide(splideElem, {
			type: "splide",
			autoplay: true,
			arrows: false,
			pagination: true,
			rewind: true,
			gap: 12,
			perPage: 1,
		}).mount();
	}
}

function mmInitSplideCross() {
	const id = ".splide-cross";
	const splideElem = document.querySelector(id);

	if (splideElem) {
		if (window.splideCrossInstance) {
			window.splideCrossInstance.destroy(true);
		}

		window.splideCrossInstance = new Splide(splideElem, {
			type: "slide",
			arrows: true,
			pagination: false,
			omitEnd		: true,
			gap: 8,
			perPage: 1,
			fixedWidth: 280,
			breakpoints: {
				768: {
					fixedWidth: 170,
				},
			},
		}).mount();
	}
}

/*********************************************************************************************
 * Creates a debounced function that delays invoking func until after duration milliseconds have elapsed since the last time the debounced function was invoked.
 *
 * @param {Function} func - The function to debounce.
 * @param {number} duration - The number of milliseconds to delay.
 * @returns {Function} - The debounced function.
 */
function debounce(func, duration) {
	let timeout;
	return function (...args) {
		const effect = () => {
			timeout = null;
			return func.apply(this, args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(effect, duration);
	};
}

/*********************************************************************************************
 * Get the full cart section ID from the DOM.
 *
 * @returns {HTMLElement} - The full cart section ID with the prefix.
 */
function mmCartSectionIdLong() {
	return document.querySelector(".mm-cart").id;
}

/*********************************************************************************************
 * Get the cart section ID from the DOM, removing the "shopify-section-" prefix.
 *
 * @returns {HTMLElement} - The cart section ID without the "shopify-section-" prefix.
 */
function mmCartSectionId() {
	return document.querySelector(".mm-cart").id.replace("shopify-section-", "");
}

/*********************************************************************************************
 * Get the cart section element from the DOM.
 *
 * @returns {HTMLElement} - The cart section element.
 */
function mmCartSectionElement() {
	return document.getElementById(`${mmCartSectionIdLong()}`);
}

/*********************************************************************************************
 * Get the cart product container element from the cart section.
 *
 * @returns {HTMLElement} - The cart product container element.
 */
function mmCartProductsContainerElement() {
	return mmCartSectionElement().querySelector("[data-products-container]");
}

/*********************************************************************************************
 * Get the cart item element for a specific product variant.
 *
 * @param {number} line_index - The line item index.
 * @returns {HTMLElement} - The cart item element.
 */
function mmCartItem(line_index) {
	return mmCartProductsContainerElement().querySelector(`[data-line-index="${line_index}"]`);
}

/*********************************************************************************************
 * Get the cart item quantity element for a specific product variant.
 *
 * @param {number} line_index - The line item index.
 * @returns {HTMLElement} - The cart item quantity element.
 */
function mmCartItemQuantityEl(line_index) {
	const itemEl = mmCartItem(line_index);
	return itemEl.querySelector("[data-item-quantity]");
}

/*********************************************************************************************
 * Get the quantity of a specific cart item.
 *
 * @param {number} line_index - The line item index.
 * @returns {number} - The quantity of the cart item.
 */
function mmGetCartItemQuantity(line_index) {
	const quantityEl = mmCartItemQuantityEl(line_index);
	return Number.parseInt(quantityEl.dataset.itemQuantity);
}

/*********************************************************************************************
 * Set the quantity of a specific cart item and update the DOM.
 *
 * @param {number} line_index - The line item index.
 * @param {number} newQuantity - The new quantity to set.
 */
function mmSetCartItemQuantity(line_index, newQuantity) {
	// Display quantity in front
	if (newQuantity >= 0) {
		const quantityEl = mmCartItemQuantityEl(line_index);
		quantityEl.dataset.itemQuantity = newQuantity;
		quantityEl.innerText = newQuantity;
	}
}

/*********************************************************************************************
 * Create a new cart element from the provided data.
 *
 * @param {Object} data - The data containing cart HTML.
 * @returns {HTMLElement} - The new cart element.
 */
function mmCartHTMLFromData(data) {
	const el = document.createElement("DIV");
	const sectionHtml =
		(data.sections && (data.sections[mmCartSectionId()] || data.sections["mm-cart"])) || "";
	el.innerHTML = sectionHtml;
	return el;
}

/*********************************************************************************************
 * Extract the items container from the new cart HTML.
 *
 * @param {Object} data - The data containing cart HTML.
 * @returns {HTMLElement} - The items container element.
 */
function extractItemsFromCartHTML(data) {
	const el = mmCartHTMLFromData(data);
	return el.querySelector("[data-products-container]");
}

/*********************************************************************************************
 * Insert cart products from the response data into the current cart in the DOM.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function insertCartProductsFromResponse(data) {
	const itemsContainer = extractItemsFromCartHTML(data);
	mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;
	return data;
}

/*********************************************************************************************
 * Extract the total price element from the new cart HTML.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {HTMLElement} - The total price element.
 */
function extractTotalPriceFromCartHTML(data) {
	const cartEl = mmCartHTMLFromData(data);
	return cartEl.querySelector("[data-cart-total-price]");
}

/*********************************************************************************************
 * Insert the total price from the response data into the current cart in the DOM.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function insertInsertTotalPriceFromResponse(data) {
	const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
	const currentTotalPriceEl = mmCartSectionElement().querySelector("[data-cart-total-price]");
	currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;
	return data;
}

/*********************************************************************************************
 * Perform an API request to fetch or update cart data.
 *
 * @param {string} method - The HTTP method (GET, POST, etc.).
 * @param {string} path - The API endpoint path.
 * @param {Object} body - The request body data.
 * @returns {Promise<Object>} - A promise resolving to the response data.
 */
function mmAPIRequest(method, path, body) {
	document.querySelector("[data-products-container]")?.classList?.add("mm-inactive");
	return fetch(window.Shopify.routes.root + path, {
		method: method,
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(body),
	})
		.then((response) => response.json())
		.then((data) => {
			document.querySelector("[data-products-container]")?.classList?.remove("mm-inactive");
			const totalItems = data.items ? data.items.reduce((total, item) => total + item.quantity, 0) : 0;
			updateCartCount(totalItems);

			if (data.status && data.status > 400) {
				throw data;
			} else {
				return data;
			}
		});
}

/*********************************************************************************************
 * Fetch the current cart data.
 *
 * @returns {Promise<Object>} - A promise resolving to the cart data.
 */
function mmGetCart() {
	return mmAPIRequest("GET", "cart.js");
}

/*********************************************************************************************
 * Open the cart drawer and fetch the latest cart data.
 */
function mmOpenCart() {
	mmGetCart();
	const cartFilter = document.querySelector(".mm-drawer-cart-filter");
	const html = document.querySelector("html");
	const body = document.body;

	if (!cartFilter || !html) return;

	cartFilter.classList.add("mm-dc-is-open");
	body && body.classList.add("stop-scrolling");
}

/*********************************************************************************************
 * Close the cart drawer and allow page scrolling.
 *
 */
function mmCloseCart() {
	document.querySelector(".mm-drawer-cart-filter").classList.remove("mm-dc-is-open");
	document.body && document.body.classList.remove("stop-scrolling");
}

/*********************************************************************************************
 * Re-render the cart inner HTML from the response data and initialize Splide carousels.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function refreshCartFromData(data) {
	if (!data.sections || !data.sections[mmCartSectionId()]) {
		return data;
	}
	const newCartEl = document.createElement("DIV");
	newCartEl.innerHTML = data.sections[mmCartSectionId()];
	const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
	innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-filter").innerHTML;

	mmSetupCrossSellDropdown();
	mmSetupCrossSellDropdownDelegated();
	mmInitSplideRea();
	// mmInitSplideCross(); // Déplacé au clic sur le dropdown
	mmSetupProductForm();

	setTimeout(() => {
		mmAddOrRemoveFreeProducts({ sections: { "mm-cart": innerCart.innerHTML } });
	}, 300);

	return data;
}

// Flag global pour empêcher les soumissions multiples
let isFormSubmitting = false;

/*********************************************************************************************
 * Sets up the cart form submission handler.
 */
function mmSetupProductForm() {
	const forms = document.querySelectorAll("[data-type='add-to-cart-form']");
	if (!forms) return;

	forms.forEach((form) => {
		if (form.dataset.mmFormInitialized) return;
		
		form.addEventListener("submit", async function (event) {
			event.preventDefault();

			// Si un formulaire est déjà en cours de soumission, on ignore
			if (isFormSubmitting) {
				console.log("Une soumission est déjà en cours");
				return;
			}

			// Sauvegarder la position de scroll actuelle
			const scrollPosition = window.scrollY;

			isFormSubmitting = true;

			try {
				const formData = new FormData(form);

				// S'assurer que la quantité est de 1 si non spécifiée
				if (!formData.get("quantity")) {
					formData.set("quantity", "1");
				}

				const response = await fetch("/cart/add.js", {
					method: "POST",
					body: formData,
				});

				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}

				const data = await response.json();
				console.log("Produit ajouté:", data);

				// Récupérer le panier mis à jour pour avoir le bon nombre d'articles
				const cartResponse = await fetch("/cart.js");
				const cartData = await cartResponse.json();
				updateCartCount(cartData.item_count);

				// Mettre à jour le panier une seule fois
				await mmRefreshCartSectionOnly();
				
				// Fermer la recherche si elle est ouverte
				const searchClearBtn = document.getElementById('mmSearchClear');
				const searchContainer = document.querySelector("[data-search-container]");
				if (searchClearBtn && searchContainer && searchContainer.classList.contains("mm-open")) {
					searchClearBtn.click();
				}

				setTimeout(() => {
					mmOpenCart();
				}, 100);

				// Restaurer la position de scroll
				window.scrollTo(0, scrollPosition);

				// Attendre que le panier soit mis à jour avant d'ajouter les produits gratuits
				setTimeout(() => {
					mmAddOrRemoveFreeProducts({
						sections: {
							"mm-cart": document.querySelector(".mm-drawer-cart-filter").innerHTML,
						},
					});
				}, 300);
			} catch (error) {
				console.error("Erreur:", error);
			} finally {
				// Réactiver le formulaire après un délai plus long
				setTimeout(() => {
					isFormSubmitting = false;
				}, 2000);
			}
		});
		form.dataset.mmFormInitialized = "true";
	});
}

/*********************************************************************************************
 * Refresh the cart and open the cart drawer
 */
function mmOpenAndRefreshCart() {
	function handleResponse() {
		const newCartEl = document.createElement("DIV");
		newCartEl.innerHTML = this.responseText;
		const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
		innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-filter").innerHTML;

		mmSetupCrossSellDropdown();
		mmInitSplideRea();
		// mmInitSplideCross();
		mmSetupProductForm();

		mmOpenCart();
	}
	const request = new XMLHttpRequest();
	request.addEventListener("load", handleResponse);
	request.open("GET", `/?section_id=${mmCartSectionId()}`, true);
	request.send();
}

/*********************************************************************************************
 * Increase the quantity of a specific product in the cart by one.
 *
 * @param {number} line_index - The line item index.
 */
function mmIncreaseProductQuantity(line_index) {
	const itemCart = mmCartItem(line_index);
	const quantity = mmGetCartItemQuantity(line_index);
	const maxQtty = parseInt(itemCart.dataset.maxQuantity, 10);
	const newQuantity = quantity + 1;

	// if (newQuantity > maxQtty) {
	// 	return;
	// }

	mmSetCartItemQuantity(line_index, newQuantity);
	mmDebouncedPushNewQuantity(line_index);
}

/*********************************************************************************************
 * Decrease the quantity of a specific product in the cart by one.
 *
 * @param {number} line_index - The line item index.
 */
function mmDecreaseProductQuantity(line_index) {
	const itemCart = mmCartItem(line_index);
	const quantity = mmGetCartItemQuantity(line_index);
	const maxQtty = parseInt(itemCart.dataset.maxQuantity, 10);
	const newQuantity = quantity - 1;

	if (newQuantity > maxQtty) {
		return;
	}

	mmSetCartItemQuantity(line_index, newQuantity);
	mmDebouncedPushNewQuantity(line_index);
}

/*********************************************************************************************
 * Remove a specific product from the cart.
 *
 * @param {number} line_index - The line item index.
 */
function mmDestroyProductFromCart(line_index) {
	const itemCart = mmCartItem(line_index);
	if (!itemCart) return;

	const newQuantity = 0;
	mmSetCartItemQuantity(line_index, newQuantity);
	mmDebouncedPushNewQuantity(line_index);
}

/*********************************************************************************************
 * Push the new quantity of a specific product to the server.
 *
 * @param {number} line_index - The line item index.
 */
function mmPushNewQuantity(line_index) {
	const quantity = mmGetCartItemQuantity(line_index);
	mmAPIRequest("POST", "cart/change.js", {
		line: line_index,
		quantity: quantity,
		sections: mmCartSectionId(),
	})
		.then(mmAddOrRemoveFreeProducts)
		.then(refreshCartFromData)
		.then((data) => {
			mmInitSplideRea();
			// mmInitSplideCross();
			mmSetupCrossSellDropdown();
		})
		.catch((error) => {
			alert(error.message);
			console.log(error);
			location.reload();
		});
}

/*********************************************************************************************
 * Remove a line item from the cart.
 *
 * @param {number|string} line_index - The index of the line item in the cart to be removed.
 */
function mmDestroyLineItemFromCart(line_index) {
	mmAPIRequest("POST", "cart/change.js", {
		line: parseInt(line_index),
		quantity: 0,
		sections: mmCartSectionId(),
	})
		.then(mmAddOrRemoveFreeProducts)
		.then(refreshCartFromData)
		.then(() => {
			mmInitSplideRea();
			// mmInitSplideCross();
			mmSetupCrossSellDropdown();
			mmSetupCrossSellDropdownDelegated();
		});
}

/*********************************************************************************************
 * Remove free product intentionally and remember user choice to not auto re-add
 *
 * @param {number|string} productId - Variant ID of the free product
 * @param {number|string} line_index - Line index to remove
 */
function mmRemoveFreeProductAndRemember(productId, line_index) {
	try {
		localStorage.setItem(`mmSkipFreeProduct:${productId}`, "1");
	} catch (e) {
		// ignore storage issues
	}
	mmDestroyLineItemFromCart(line_index);
}

/*********************************************************************************************
 * Debounced function to push new quantity of a specific product to the server.
 *
 * @param {number} line_index - The line item index.
 */
const mmDebouncedPushNewQuantity = debounce(function (line_index, maxQtty) {
	const quantity = mmGetCartItemQuantity(line_index);

	if (quantity > maxQtty) {
		return;
	}
	mmPushNewQuantity(line_index);
}, 300);

/*********************************************************************************************
 * Update the cart count bubble with the given value.
 *
 * @param {number} value - The new cart count value.
 */
function updateCartCount(value) {
	const cartBubbles = document.querySelectorAll(".mm-cart-count-bubble");
	cartBubbles.forEach((bubble) => {
		if (value > 0) {
			bubble.classList.remove("mm-none");
			bubble.innerText = `(${value})`;
		} else {
			bubble.classList.add("mm-none");
		}
	});
}

/*********************************************************************************************
 * Add or remove free products from the cart based on conditions.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function mmAddOrRemoveFreeProducts(data) {
	if (!data.sections) {
		return data;
	}
	const el = mmCartHTMLFromData(data);
	const freeProductEls = el.querySelector("[data-free-products]");
	if (!freeProductEls) {
		return data;
	}
	let freeProductCounts = 0;

	// creates an object like { 44058675: 1, 44058001: 0 }
	// where key is free product id and value, its quantity
		const candidateEls = freeProductEls.children && freeProductEls.children.length > 0 ? Array.from(freeProductEls.children) : [freeProductEls];
		const productsParams = candidateEls.reduce((param, freeProductEl) => {
		const productId = freeProductEl.dataset.variantId;
		const isFree = freeProductEl.dataset.freeProduct == "true";
		const itemEl = document.querySelector(`[data-cart-item-id="${productId}"]`);
		const skipKey = `mmSkipFreeProduct:${productId}`;
		let userSkipped = false;
		try {
			userSkipped = localStorage.getItem(skipKey) === "1";
		} catch (e) {
			userSkipped = false;
		}
		if (isFree) {
			freeProductCounts += 1;
		}
		if (!isFree) {
			// seuil non atteint: s'assurer de nettoyer le flag de skip et retirer l'item s'il est présent
			try {
				localStorage.removeItem(skipKey);
			} catch (e) {}
			if (itemEl) {
				param[productId] = 0;
			}
		} else if (itemEl && isFree) {
			console.log("do nothing, item is already added");
			// do nothing, item is already added
		} else if (!itemEl && isFree && !userSkipped) {
			console.log("item is absent but should be added", productId);
			// item is absent but should be added
			param[productId] = 1;
		} else if (!itemEl && isFree && userSkipped) {
			console.log("user skipped free product, do not auto-add", productId);
		}
		return param;
	}, {});

	// Add or remove free products only if needed
	if (Object.keys(productsParams).length > 0) {
		console.log("productsParams", productsParams);
		mmAPIRequest("POST", "cart/update.js", { updates: productsParams, sections: mmCartSectionId() }).then(refreshCartFromData);
	}
	return data;
}

/*********************************************************************************************
 * Add a free product to the cart and optionally open the cart drawer.
 *
 * @param {number} productId - The free product ID to add.
 * @param {Object} options - Options for adding the product.
 * @param {number} [options.quantity=1] - The quantity to add.
 * @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding the product.
 * @param {HTMLElement} clickedElem - The element that was clicked to trigger this action.
 */
function mmAddFreeProductToCart(productId, { quantity = 1, openCart = true }, clickedElem) {
	// Debounce on the CTA
	clickedElem.innerText = "AJOUTÉ !";
	clickedElem.classList.add("mm-disabled");

	// Ajouter le free product
	mmAddProductToCart(productId, { openCart: false });
}

/*********************************************************************************************
 * Loaded Listenner
 *
 */
window.addEventListener("DOMContentLoaded", (event) => {
	mmGetCart();
});

document.addEventListener(
	"DOMContentLoaded",
	() => {
		mmSetupCrossSellDropdown();
		mmSetupCrossSellDropdownDelegated();
		mmInitSplideRea();
		// mmInitSplideCross();
		mmSetupProductForm();
		mmSetupVariantSelector();
		window.mmIncreaseCrossSellQuantity = mmIncreaseCrossSellQuantity;
		window.mmDecreaseCrossSellQuantity = mmDecreaseCrossSellQuantity;
	},
	{ once: true }
);

/*********************************************************************************************
 * Setup the cross-sell dropdown functionality
 */
function mmSetupCrossSellDropdown() {
	// Vérifier si le dropdown est ouvert par défaut (car produits dans le panier)
	const content = document.querySelector(".mm-dc-cross-sell .mm-dropdown-content");
	if (content && !content.classList.contains("mm-dropdown-closed")) {
		// Petit délai pour s'assurer que le DOM est prêt
		setTimeout(() => {
			mmInitSplideCross();
		}, 50);
	}
}

/*********************************************************************************************
 * Setup a delegated click handler for dropdown toggle (robust after DOM refresh)
 */
function mmSetupCrossSellDropdownDelegated() {
	if (window.mmDropdownHandlerAttached) {
		return;
	}
	document.addEventListener("click", (event) => {
		const btn = event.target.closest(".mm-dropdown-btn");
		if (!btn) return;
		const container = btn.closest(".mm-dc-cross-sell");
		if (!container) return;
		const content = container.querySelector(".mm-dropdown-content");
		if (!content) return;
		
		const isClosed = content.classList.contains("mm-dropdown-closed");
		content.classList.toggle("mm-dropdown-closed");
		
		// Si on ouvre le dropdown, on initialise le slider si ce n'est pas déjà fait
		// ou on le rafraîchit pour être sûr qu'il a la bonne taille
		if (isClosed) {
			// Petit délai pour laisser le temps au display:block de s'appliquer
			setTimeout(() => {
				mmInitSplideCross();
			}, 50);
		}
	});
	window.mmDropdownHandlerAttached = true;
}

/*********************************************************************************************
 * Increase the quantity of a cross-sell product
 *
 * @param {string} productId - The product ID
 */
function mmIncreaseCrossSellQuantity(productId) {
	const quantityInput = document.getElementById(`cross-sell-quantity-${productId}`);
	const quantityDisplay = document.getElementById(`cross-sell-quantity-display-${productId}`);
	const currentQuantity = parseInt(quantityInput.value);
	const maxQuantity = parseInt(quantityInput.getAttribute("max")) || 999;

	if (currentQuantity < maxQuantity) {
		const newQuantity = currentQuantity + 1;
		quantityInput.value = newQuantity;
		quantityDisplay.textContent = newQuantity;
		quantityDisplay.setAttribute("data-item-quantity", newQuantity);
	}
}

/*********************************************************************************************
 * Decrease the quantity of a cross-sell product
 *
 * @param {string} productId - The product ID
 */
function mmDecreaseCrossSellQuantity(productId) {
	const quantityInput = document.getElementById(`cross-sell-quantity-${productId}`);
	const quantityDisplay = document.getElementById(`cross-sell-quantity-display-${productId}`);
	const currentQuantity = parseInt(quantityInput.value);

	if (currentQuantity > 1) {
		const newQuantity = currentQuantity - 1;
		quantityInput.value = newQuantity;
		quantityDisplay.textContent = newQuantity;
		quantityDisplay.setAttribute("data-item-quantity", newQuantity);
	}
}

/*********************************************************************************************
 * Refresh the cart products only
 */
function mmRefreshCartProductsOnly() {
	fetch(`/?section_id=${mmCartSectionId()}`)
		.then((response) => response.text())
		.then((html) => {
			const tempDiv = document.createElement("div");
			tempDiv.innerHTML = html;
			const newProductsContainer = tempDiv.querySelector("[data-products-container]");
			const currentProductsContainer = document.querySelector("[data-products-container]");
			if (newProductsContainer && currentProductsContainer) {
				currentProductsContainer.innerHTML = newProductsContainer.innerHTML;
			}
			mmSetupProductForm();
		});
}

/*********************************************************************************************
 * Refresh the cart section only
 */
function mmRefreshCartSectionOnly() {
	return fetch(`/?section_id=${mmCartSectionId()}`)
		.then((response) => response.text())
		.then((html) => {
			const tempDiv = document.createElement("div");
			tempDiv.innerHTML = html;
			const newCartSection = tempDiv.querySelector(".mm-drawer-cart-filter");
			const currentCartSection = document.querySelector(".mm-drawer-cart-filter");
			if (newCartSection && currentCartSection) {
				currentCartSection.innerHTML = newCartSection.innerHTML;
			}
			mmSetupCrossSellDropdown();
			mmSetupCrossSellDropdownDelegated();
			mmInitSplideRea();
			// mmInitSplideCross();
			mmSetupProductForm();
		});
}

/*********************************************************************************************
 * Setup the variant selector functionality
 */
function mmSetupVariantSelector() {
	// Functionality moved to mm-global.js for better reliability
}
